import "@/styles/components/google-translate-widget.css";

export const initGoogleTranslateWidget = () => {
  const container = document.getElementById("google_translate_element");

  if (!container) {
    return;
  }

  // Wait for Google Translate to render and populate the select
  const observer = new MutationObserver((_mutations, obs) => {
    const select = container.querySelector(".goog-te-combo");

    if (select && select.options.length > 1) {
      obs.disconnect();
      buildWidget(container, select);
    }
  });

  observer.observe(container, { childList: true, subtree: true });
};

function buildWidget(container, select) {
  // Tracks whether a translation is currently active so we know when to reset
  let isTranslated = false;

  // Hide native select but keep it in the DOM for Google Translate to use
  Object.assign(select.style, {
    position: "absolute",
    opacity: "0",
    pointerEvents: "none",
    height: "0",
    width: "0",
    overflow: "hidden",
  });
  select.setAttribute("aria-hidden", "true");
  select.setAttribute("tabindex", "-1");

  // Move select out of the gadget so we can hide the gadget (which carries the
  // "Powered by Google Translate" branding) without disrupting GT's event listeners
  container.appendChild(select);

  const gadget = container.querySelector(".goog-te-gadget");
  if (gadget) {
    gadget.style.display = "none";
  }

  // Build wrapper
  const wrapper = document.createElement("div");
  wrapper.className = "gt-widget";

  // Build list (positioned above the trigger)
  const list = document.createElement("ul");
  list.className = "gt-list";
  list.setAttribute("role", "listbox");

  Array.from(select.options).forEach((option) => {
    if (!option.value) {
      return; // skip placeholder
    }

    const li = document.createElement("li");
    li.className = "gt-option";
    li.setAttribute("role", "option");
    li.setAttribute("data-value", option.value);
    li.setAttribute("aria-selected", "false");
    li.textContent = option.text;

    li.addEventListener("click", (e) => {
      e.stopPropagation();
      isTranslated = true;
      selectLanguage(wrapper, list, button, label, select, option.value, option.text);
    });

    list.appendChild(li);
  });

  // Build trigger button
  const button = document.createElement("button");
  button.type = "button";
  button.className = "gt-trigger";
  button.setAttribute("aria-haspopup", "listbox");
  button.setAttribute("aria-expanded", "false");

  const label = document.createElement("span");
  label.className = "gt-label";
  label.textContent = "Translate";

  const arrow = document.createElement("span");
  arrow.className = "gt-arrow";
  arrow.setAttribute("aria-hidden", "true");
  arrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" fill="currentColor"><path d="M11.0257 4.43648L6.44459 8.49269C6.25244 8.66084 5.96485 8.66084 5.77269 8.49269L1.19157 4.43648C0.995045 4.24846 0.982033 3.93962 1.16205 3.73586C1.34206 3.5321 1.65125 3.50568 1.86347 3.67594L6.10864 7.433L10.3538 3.67594C10.4888 3.54681 10.684 3.50186 10.8622 3.55891C11.0404 3.61596 11.1727 3.77346 11.1932 3.96154C11.2137 4.14962 11.1178 4.33241 10.9509 4.41877Z"/></svg>`;

  button.appendChild(label);
  button.appendChild(arrow);

  wrapper.appendChild(list);
  wrapper.appendChild(button);
  container.appendChild(wrapper);

  // Toggle dropdown
  button.addEventListener("click", (e) => {
    e.stopPropagation();
    const isOpen = wrapper.classList.toggle("gt-open");
    button.setAttribute("aria-expanded", String(isOpen));
  });

  document.addEventListener("click", () => {
    if (wrapper.classList.contains("gt-open")) {
      wrapper.classList.remove("gt-open");
      button.setAttribute("aria-expanded", "false");
    }
  });

  // Reset widget label when Google Translate cancels/reverts the translation.
  // Watch body.style.top — Google sets this to the bar height when translating and
  // clears it when the bar is dismissed. Use one observer for both concerns:
  //  1. Keep sticky header below the bar while it's visible.
  //  2. Reset the widget label when the bar is dismissed after a translation.
  const siteHeader = document.querySelector(".site-header");
  new MutationObserver(() => {
    const offset = parseInt(document.body.style.top) || 0;

    if (siteHeader) {
      siteHeader.style.top = offset > 0 ? `${offset}px` : "";
    }

    if (offset === 0 && isTranslated) {
      isTranslated = false;
      label.textContent = "Translate";
      list.querySelectorAll(".gt-option").forEach((item) => {
        item.setAttribute("aria-selected", "false");
      });
    }
  }).observe(document.body, { attributes: true, attributeFilter: ["style"] });
}

function selectLanguage(wrapper, list, button, label, select, value, text) {
  label.textContent = text;

  list.querySelectorAll(".gt-option").forEach((item) => {
    item.setAttribute("aria-selected", item.dataset.value === value ? "true" : "false");
  });

  wrapper.classList.remove("gt-open");
  button.setAttribute("aria-expanded", "false");

  select.value = value;
  select.dispatchEvent(new Event("change"));
}
